import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Dashboard = ({ token, role }) => {
  const [stats, setStats] = useState({
    totalSiswa: 0, totalGuru: 0, totalKelas: 0,
    totalHadir: 0, totalSakit: 0, totalIzin: 0, totalAlfa: 0
  });
  const [infoSekolah, setInfoSekolah] = useState({});

  useEffect(() => {
    fetchData();
  }, [token]);

  const fetchData = async () => {
    try {
      const siswaId = localStorage.getItem('siswaId');
      const configParams = {};
      
      // Jika yang login ortu atau siswa, kirim parameter siswa_id secara dinamis
      if ((role === 'ortu' || role === 'siswa') && siswaId) {
        configParams.siswa_id = siswaId;
      }

      const resStats = await axios.get('/api/dashboard', {
        params: configParams,
        headers: { Authorization: `Bearer ${token}` }
      });
      setStats(resStats.data);

      const resSettings = await axios.get('/api/settings', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setInfoSekolah(resSettings.data);
    } catch (err) { 
      console.error(err); 
    }
  };

  // --- TAMPILAN KHUSUS ORANG TUA & SISWA ---
  if (role === 'ortu' || role === 'siswa') {
    return (
      <div style={{ paddingBottom: '50px' }}>
        {/* HEADER ORTU */}
        <div style={{ marginBottom: '30px', background: 'linear-gradient(135deg, #4361ee, #3a0ca3)', padding: '30px', borderRadius: '15px', color: 'white', boxShadow: '0 4px 15px rgba(67, 97, 238, 0.3)' }}>
            <h2 style={{ margin: 0, fontSize: '24px' }}>Halo, {role === 'ortu' ? 'Bapak/Ibu Orang Tua Siswa' : 'Sobat Siswa'}! 👋</h2>
            <p style={{ margin: '5px 0 0', opacity: 0.9 }}>Berikut adalah ringkasan kehadiran akademik siswa di <b>{infoSekolah.nama_sekolah || 'SMA Negeri 10 Fajar Harapan'}</b></p>
        </div>

        {/* KARTU KEHADIRAN (Fokus Personal Personal, Variabel Poin Rusak Dihapus) */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '20px', marginBottom: '30px' }}>
            <div style={{ background: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', borderLeft: '5px solid #10b981' }}>
                <div style={{ fontSize: '12px', color: '#64748b', fontWeight: 'bold', textTransform: 'uppercase' }}>Total Kehadiran (Hadir)</div>
                <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#059669' }}>{stats.totalHadir || 0}</div>
            </div>

            <div style={{ background: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', borderLeft: '5px solid #f59e0b' }}>
                <div style={{ fontSize: '12px', color: '#64748b', fontWeight: 'bold', textTransform: 'uppercase' }}>Total Absen (Sakit/Izin)</div>
                <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#d97706' }}>
                    {(stats.totalSakit || 0) + (stats.totalIzin || 0)}
                </div>
            </div>
             
            <div style={{ background: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', borderLeft: '5px solid #ef4444' }}>
                <div style={{ fontSize: '12px', color: '#64748b', fontWeight: 'bold', textTransform: 'uppercase' }}>Total Tanpa Keterangan (Alfa)</div>
                <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#dc2626' }}>{stats.totalAlfa || 0}</div>
            </div>
        </div>

        {/* INFO PENTING SEKOLAH */}
        <div style={{ background: '#fff', padding: '25px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
            <h3 style={{ margin: '0 0 15px', color: '#1e293b', borderBottom:'2px solid #f1f5f9', paddingBottom:'10px' }}>📢 Pengumuman Orang Tua</h3>
            <p style={{ color: '#475569', lineHeight: '1.6' }}>
                Harap memantau grafik kehadiran putra/putri Anda secara berkala pada sistem informasi sekolah ini. 
                Jika terdapat ketidakhadiran tanpa keterangan yang tidak wajar, mohon segera konfirmasi ke pihak sekolah atau Wali Kelas.
                <br/><br/>
                <i>Teria kasih atas perhatian dan kerja samanya.</i>
            </p>
        </div>
      </div>
    );
  }

  // --- TAMPILAN ADMIN, GURU, PIKET, KEPSEK (Dashboard Global) ---
  return (
    <div style={{ paddingBottom: '50px' }}>
      {/* HEADER ADMIN */}
      <div style={{ marginBottom: '30px', background: 'linear-gradient(135deg, #1e293b, #0f172a)', padding: '30px', borderRadius: '15px', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
              <h2 style={{ margin: 0, fontSize: '24px' }}>Dashboard {role ? role.toUpperCase() : 'USER'}</h2>
              <p style={{ margin: '5px 0 0', opacity: 0.8 }}>Selamat datang di Sistem Informasi <b>{infoSekolah.nama_sekolah || 'Sekolah'}</b></p>
          </div>
          <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: '32px', fontWeight: 'bold' }}>{new Date().toLocaleTimeString('id-ID', {hour:'2-digit', minute:'2-digit'})}</div>
              <div style={{ fontSize: '14px', opacity: 0.8 }}>{new Date().toLocaleDateString('id-ID', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}</div>
          </div>
      </div>

      {/* STATISTIK UTAMA */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '20px', marginBottom: '30px' }}>
          <div style={{ background: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', borderLeft: '5px solid #4361ee' }}>
              <div style={{ fontSize: '12px', color: '#64748b', fontWeight: 'bold' }}>TOTAL SISWA</div>
              <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#1e293b' }}>{stats.totalSiswa}</div>
          </div>
          <div style={{ background: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', borderLeft: '5px solid #8b5cf6' }}>
              <div style={{ fontSize: '12px', color: '#64748b', fontWeight: 'bold' }}>TOTAL GURU</div>
              <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#1e293b' }}>{stats.totalGuru}</div>
          </div>
          <div style={{ background: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', borderLeft: '5px solid #f59e0b' }}>
              <div style={{ fontSize: '12px', color: '#64748b', fontWeight: 'bold' }}>TOTAL KELAS</div>
              <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#1e293b' }}>{stats.totalKelas}</div>
          </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>
          
          {/* RINGKASAN KEHADIRAN KESELURUHAN */}
          <div style={{ background: 'white', padding: '25px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
              <h3 style={{ margin: '0 0 20px', color: '#334155' }}>📊 Data Akumulasi Kehadiran Siswa</h3>
              
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                  <div style={{ background: '#ecfdf5', padding: '15px', borderRadius: '8px', color: '#065f46', textAlign: 'center' }}>
                      <span style={{ fontSize: '30px', fontWeight: 'bold', display: 'block' }}>{stats.totalHadir}</span>
                      <span style={{ fontSize: '13px', fontWeight: '600' }}>HADIR</span>
                  </div>
                  <div style={{ background: '#fffbeb', padding: '15px', borderRadius: '8px', color: '#92400e', textAlign: 'center' }}>
                      <span style={{ fontSize: '30px', fontWeight: 'bold', display: 'block' }}>{stats.totalSakit}</span>
                      <span style={{ fontSize: '13px', fontWeight: '600' }}>SAKIT</span>
                  </div>
                  <div style={{ background: '#eff6ff', padding: '15px', borderRadius: '8px', color: '#1e40af', textAlign: 'center' }}>
                      <span style={{ fontSize: '30px', fontWeight: 'bold', display: 'block' }}>{stats.totalIzin}</span>
                      <span style={{ fontSize: '13px', fontWeight: '600' }}>IZIN</span>
                  </div>
                  <div style={{ background: '#fef2f2', padding: '15px', borderRadius: '8px', color: '#991b1b', textAlign: 'center' }}>
                      <span style={{ fontSize: '30px', fontWeight: 'bold', display: 'block' }}>{stats.totalAlfa}</span>
                      <span style={{ fontSize: '13px', fontWeight: '600' }}>ALFA</span>
                  </div>
              </div>
          </div>

          {/* INFO SEKOLAH */}
          <div style={{ background: '#0f172a', padding: '30px', borderRadius: '12px', color: 'white', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <h3 style={{ margin: '0 0 10px' }}>📢 Info Pihak Manajemen Sekolah</h3>
              <p style={{ opacity: 0.8, lineHeight: '1.6' }}>
                  <b>Halo, {role ? role.toUpperCase() : 'USER'}!</b><br/><br/>
                  Sistem KBM, dashboard, dan rekapitulasi bulanan dinamis berjalan real-time. 
                  Pastikan Guru Piket mengisi jurnal aktivitas harian sebelum jam operasional sekolah berakhir.
                  <br/><br/>
                  <i>"Sistem yang baik mempermudah transparansi akademik."</i>
              </p>
          </div>
      </div>
    </div>
  );
};

export default Dashboard;